<script lang="ts">import { getIcon } from "../data/icons";
import { t, Verbiage } from "@infinitro/content";
const WarningIcon = getIcon("WarningIcon");
export let height = 32;
export let width = 32;
</script>

{#if typeof WarningIcon === 'string'}
	<img src={WarningIcon} alt={$t(Verbiage.warning_icon_alt, 'alts')} />
{:else if typeof WarningIcon === 'function'}
	<svelte:component this={WarningIcon} {width} {height} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
